import { styled } from "@mui/material/styles";
import MuiSwitch, { SwitchProps } from "@mui/material/Switch";
import Circle from "@mui/icons-material/Circle";
import CircleOutlined from "@mui/icons-material/CircleOutlined";

const StyledSwitch = styled(MuiSwitch)(() => ({
  height: "30px",
  padding: "4px",
  transformOrigin: "right center",
  width: "46px",

  "& .MuiSwitch-thumb": {
    color: "black",
  },
  "& .MuiSwitch-track": {
    background: "transparent",
    border: "2px solid black",
    borderRadius: "14px",
    opacity: 1,
  },
  "& .MuiSwitch-switchBase": {
    color: "black",
    padding: "5px",
    transform: "scale(0.6)",

    "&.Mui-checked": {
      color: "black",
      transform: "scale(0.6) translateX(26px)",

      "& + .MuiSwitch-track": {
        background: "transparent",
        opacity: 1,
      },
    },
  },
}));

const Switch = ({ ...props }: SwitchProps) => {
  return (
    <StyledSwitch
      disableRipple
      {...props}
      icon={<CircleOutlined fontSize="small" />}
      checkedIcon={<Circle fontSize="small" />}
    />
  );
};

export default Switch;
